import { apiRequest } from './api';

export const rdsoService = {
  getRdsoContent: () => apiRequest('/api/rdso')
};
